<template>
    <div class="CourseList">
        <div class="container-fluid blue-bg centers-list pb-0">
            <div class="container align-middle">
                <form method="get">
                    <div class="row">
                        <div class="col-sm-3">
                            <div class="choose-course">
                                <select
                                    name="lang"
                                    v-model="langId"
                                    @change="fetchCoursesAndUpdate"
                                >
                                    <option :value="null">{{ $t('select_language') }}</option>
                                    <option value="1">Английский язык</option>
                                    <option value="2">Испанский язык</option>
                                    <option value="3">Немецкий язык</option>
                                    <option value="4">Французкий язык</option>
                                    <option value="5">Китайский язык</option>
                                    <option value="6">Русский язык</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="choose-age">
                                <select
                                    name="age"
                                    v-model="ageId"
                                    @change="fetchCoursesAndUpdate"
                                >
                                    <option :value="null"
                                        >{{ $t('Age') }}</option
                                    >
                                    <option value="1">дошкольник</option>
                                    <option value="2">школьник 1-4 классы</option>
                                    <option value="3">родитель</option>
                                </select>
                            </div>
                        </div>
                        <!-- <div class="col-sm-4">
                            <div class="knopka">
                                <input type="submit" value="Подобрать курс" />
                            </div>
                        </div> -->
                    </div>
                </form>
            </div>
        </div>

        <div class="container-fluid white-bg centers-list fr-page">
            <div class="container align-middle">
                <div class="row">
                    <div class="col-12 home-first">
                        <h1 class="title" v-if="courses.length > 0">
                            Найдено курсов
                            <span class="strong-red">{{ courses.length }}</span>
                        </h1>
                    </div>
                </div>

                <!-- <course-list-subscription-item
                    v-if="courses.length > 0"
                    @order="orderSubscription"
                /> -->

                <courses-list-item
                    v-for="(item, index) in courses"
                    :key="item.idcourse"
                    :last-item="index === courses.length - 1"
                    :course="item"
                    :demo-button-text="courseDemoButtonLabel(item)"
                    @order="order"
                    @demo="demo(item)"
                />
            </div>
        </div>

        <!-- <Lang1 v-if="langId == 1 && !ageId" />
        <Lang1Age1 v-if="langId == 1 && ageId == 1" />
        <Lang1Age2 v-if="langId == 1 && ageId == 2" />
        <Lang1Age3 v-if="langId == 1 && ageId == 3" />
        <Lang2 v-if="langId == 2 && !ageId" />
        <Lang3 v-if="langId == 3 && !ageId" /> -->

        <div class="container-fluid feedback-head-bg"></div>
        <!-- <entry /> -->
    </div>
</template>

<script>
import CoursesListItem from "./CoursesListItem";
import courseApi from "../../data/CourseApi";
import Entry from "../Entry";
import Lang1 from "../CourseComponents/texts/Lang1";
import Lang1Age1 from "../CourseComponents/texts/Lang1Age1";
import Lang1Age2 from "../CourseComponents/texts/Lang1Age2";
import Lang1Age3 from "../CourseComponents/texts/Lang1Age3";
import Lang2 from "../CourseComponents/texts/Lang2";
import Lang3 from "../CourseComponents/texts/Lang3";
import CourseListSubscriptionItem from "../CourseListSubscriptionItem";

export default {
    name: "CoursesList",
    components: {
        CourseListSubscriptionItem,
        CoursesListItem,
        Entry,
        Lang1,
        Lang1Age1,
        Lang1Age2,
        Lang1Age3,
        Lang2,
        Lang3,
    },
    data() {
        return {
            courses: [],
            error: null,
            loading: false,
            ageId: null,
            langId: null,
            diffId: null,
            security: "security",
            metaDescription:
                "☝☝☝☝☝ «HomeTeacher» – уникальный формат видеоуроков от языковых центров «Полиглотики»! Каждое занятие – синтез полезной информации и увлекательных заданий для детей от года до 12 лет.",
            metaDescriptions: {
                "lang=1":
                    "☝☝☝☝☝ Онлайн уроки английского языка для детей от профессиональных педагогов сети центров Полиглотики - ✅ Различные программы - ✅ Доступный формат - 💲 Низкие цены.",
                "lang=1&age=1":
                    "☝☝☝☝☝ Онлайн курсы английского языка для малышей от профессиональных педагогов сети центров Полиглотики - ✅ Различные программы - ✅ Удобный формат - 💲 Доступные цены.",
                "lang=1&age=2":
                    "☝☝☝☝☝ Онлайн курсы английского языка для дошкольников от профессиональных педагогов сети центров Полиглотики - ✅ Множество программ - ✅ Удобный формат - 💲 Низкие цены.",
                "lang=1&age=3":
                    "☝☝☝☝☝ Онлайн курсы английского языка для школьников от педагогов сети языковых центров Полиглотики - ✅ Множество программ - ✅ Удобный формат - 💲 Низкие цены.",
                "lang=1&age=4":
                    "☝☝☝☝☝ Онлайн уроки английского языка для детей 12 -17 от педагогов сети языковых центров Полиглотики - ✅ Множество программ - ✅ Удобный формат - 💲 Доступные цены.",
                "lang=2":
                    "☝☝☝☝☝ Онлайн уроки испанского языка для детей от профессиональных педагогов - ✅ Множество программ - ✅ Уникальная методика - ✅ Удобный формат - 💲 Доступные цены.",
                "lang=2&age=1":
                    "☝☝☝☝☝ Онлайн уроки испанского языка для малышей от профессиональных педагогов - ✅ Множество программ - ✅ Уникальная методика - ✅ Удобный формат - 💲 Низкие цены.",
                "lang=2&age=2":
                    "☝☝☝☝☝ Онлайн уроки испанского языка для дошкольников от профессиональных педагогов - ✅ Программы разного уровня - ✅ Уникальная методика - ✅ Удобный формат - 💲 Низкие цены.",
                "lang=2&age=3":
                    "☝☝☝☝☝ Онлайн уроки испанского языка для школьников от профессиональных педагогов - ✅ Программы разного уровня - ✅ Реальный результат - ✅ Удобный формат - 💲 Низкие цены.",
                "lang=2&age=4":
                    "☝☝☝☝☝ Онлайн уроки испанского языка для детей 12 -17 лет от профессиональных педагогов - ✅ Программы разного уровня - ✅ Реальный результат - ✅ Удобный формат - 💲 Доступные цены.",
                "lang=3":
                    "☝☝☝☝☝ Онлайн курсы немецкого языка для детей от педагогов сети языковых центров Полиглотики - ✅ Программы различного уровня - ✅ Реальный результат - ✅ Удобный формат - 💲 Доступные цены.",
                "lang=3&age=1":
                    "☝☝☝☝☝ Онлайн курсы немецкого языка для малышей от педагогов сети языковых центров Полиглотики - ✅ Программы различного уровня - ✅ Быстрый результат - ✅ Удобный формат - 💲 Доступные цены.",
                "lang=3&age=2":
                    "☝☝☝☝☝ Онлайн курсы немецкого языка для дошкольников от педагогов сети языковых центров Полиглотики - ✅ Программы различного уровня - ✅ Быстрый результат - ✅ Удобный формат - 💲 Низкие цены.",
                "lang=3&age=3":
                    "☝☝☝☝☝ Онлайн курсы немецкого языка для школьников от педагогов сети языковых центров Полиглотики - ✅ Программы различного уровня - ✅ Быстрый результат - ✅ Удобный формат - 💲 Низкие цены.",
                "lang=3&age=4":
                    "☝☝☝☝☝ Онлайн курсы немецкого языка для детей 12 -17 от педагогов сети языковых центров Полиглотики - ✅ Программы различного уровня - ✅ Быстрый результат - ✅ Удобный формат - 💲 Низкие цены.",
                "lang=4":
                    "☝☝☝☝☝ Дистанционные курсы французского языка для детей от профессиональных педагогов сети языковых центров Полиглотики - ✅ Программы различного уровня - ✅ Удобный формат - 💲 Низкие цены.",
                "lang=4&age=1":
                    "☝☝☝☝☝ Дистанционные курсы французского языка для малышей от профессиональных педагогов сети языковых центров Полиглотики - ✅ Программы различного уровня - ✅ Удобный формат - 💲 Приятные цены.",
                "lang=4&age=2":
                    "☝☝☝☝☝ Дистанционные курсы французского языка для дошкольников от профессиональных педагогов сети языковых центров Полиглотики - ✅ Множество программ - ✅ Удобный формат - 💲 Приятные цены.",
                "lang=4&age=3":
                    "☝☝☝☝☝ Дистанционные курсы французского языка для школьников от профессиональных педагогов сети языковых центров Полиглотики - ✅ Множество программ - ✅ Удобный формат - 💲 Приятные цены.",
                "lang=4&age=4":
                    "☝☝☝☝☝ Дистанционные курсы французского языка для детей 12 -17 лет от профессиональных педагогов сети языковых центров Полиглотики - ✅ Различные программы - ✅ Удобный формат - 💲 Доступные цены.",
                "lang=5":
                    "☝☝☝☝☝ Дистанционные курсы китайского языка для детей от профессиональных педагогов сети языковых центров Полиглотики - ✅ Различные программы - ✅ Удобный формат - 💲 Низкие цены.",
                "lang=5&age=1":
                    "☝☝☝☝☝ Дистанционные курсы китайского языка для малышей от профессиональных педагогов сети языковых центров Полиглотики - ✅ Различные программы - ✅ Удобный формат - 💲 Низкие цены.",
                "lang=5&age=2":
                    "☝☝☝☝☝ Дистанционные курсы китайского языка для дошкольников от профессиональных педагогов сети языковых центров Полиглотики - ✅ Множество программ - ✅ Удобный формат - 💲 Низкие цены.",
                "lang=5&age=3":
                    "☝☝☝☝☝ Дистанционные курсы китайского языка для школьников от профессиональных педагогов сети языковых центров Полиглотики - ✅ Уникальные программы - ✅ Удобный формат - 💲 Низкие цены.",
                "lang=5&age=4":
                    "☝☝☝☝☝ Дистанционные курсы китайского языка для детей 12 -17 от профессиональных педагогов сети языковых центров Полиглотики - ✅ Уникальные программы - ✅ Удобный формат - 💲 Доступные цены.",
                "lang=6":
                    "☝☝☝☝☝ Дистанционные уроки русского языка для детей от профессиональных педагогов сети языковых центров Полиглотики - ✅ Уникальные программы - ✅ Удобный формат - 💲 Доступные цены.",
                "lang=6&age=1":
                    "☝☝☝☝☝ Дистанционные уроки русского языка для малышей от профессиональных педагогов сети языковых центров Полиглотики - ✅ Уникальные программы - ✅ Удобный формат - 💲 Доступные цены.",
                "lang=6&age=2":
                    "☝☝☝☝☝ Дистанционные уроки русского языка для дошкольников от профессиональных педагогов сети языковых центров Полиглотики - ✅ Уникальные программы - ✅ Удобный формат - 💲 Доступные цены.",
                "lang=6&age=3":
                    "☝☝☝☝☝ Дистанционные уроки русского языка для школьников от профессиональных педагогов сети языковых центров Полиглотики - ✅ Авторские программы - ✅ Удобный формат - 💲 Доступные цены.",
                "lang=6&age=4":
                    "☝☝☝☝☝ Дистанционные уроки русского языка для детей 12 -17 от профессиональных педагогов сети языковых центров Полиглотики - ✅ Проверенные программы - ✅ Удобный формат - 💲 Доступные цены.",
                "age=2":
                    "☝☝☝☝☝ Онлайн уроки иностранных языков для дошкольников от профессиональных педагогов сети языковых центров Полиглотики - ✅ Различные программы - ✅ Доступный формат - 💲 Приятные цены.",
                "age=1":
                    "☝☝☝☝☝ Онлайн уроки иностранных языков для малышей от профессиональных педагогов сети языковых центров Полиглотики - ✅ Различные программы - ✅ Доступный формат - 💲 Приятные цены.",
                "age=3":
                    "☝☝☝☝☝ Онлайн уроки иностранных языков для школьников от профессиональных педагогов сети языковых центров Полиглотики - ✅ Авторские программы - ✅ Доступный формат - 💲 Приятные цены.",
                "":
                    "☝☝☝☝☝ Онлайн уроки иностранных языков для детей от профессиональных педагогов сети языковых центров Полиглотики - ✅ Различные программы - ✅ Доступный формат - 💲 Низкие цены.",
                "age=4":
                    "☝☝☝☝☝ Онлайн уроки иностранных языков для детей 12 -17 лет от профессиональных педагогов сети языковых центров Полиглотики - ✅ Авторские программы - ✅ Доступный формат - 💲 Низкие цены.",
            },
            metaTitle:
                "Авторские онлайн-курсы иностранных языков для детей HomeTeacher",
            metaTitles: {
                "lang=1": "Уроки английского языка для детей онлайн",
                "lang=1&age=1": "Английский язык для малышей онлайн",
                "lang=1&age=2": "Английский язык для дошкольников онлайн",
                "lang=1&age=3":
                    "Дистанционное обучение английскому языку для школьников",
                "lang=1&age=4": "Английский язык для детей 12 -17 лет онлайн",
                "lang=2": "Испанский язык для детей онлайн",
                "lang=2&age=1": "Испанский язык для малышей онлайн",
                "lang=2&age=2": "Испанский язык для дошкольников онлайн",
                "lang=2&age=3": "Испанский язык для для школьников онлайн",
                "lang=2&age=4": "Испанский язык для детей 12 -17 лет",
                "lang=3": "Немецкий язык для детей онлайн",
                "lang=3&age=1": "Немецкий язык для малышей онлайн",
                "lang=3&age=2": "Немецкий язык для дошкольников онлайн",
                "lang=3&age=3": "Немецкий язык для для школьников онлайн",
                "lang=3&age=4": "Немецкий язык для детей 12 -17 лет онлайн",
                "lang=4": "Французский язык для детей онлайн",
                "lang=4&age=1": "Французский язык для малышей онлайн",
                "lang=4&age=2": "Французский язык для дошкольников онлайн",
                "lang=4&age=3": "Французский язык для для школьников онлайн",
                "lang=4&age=4": "Французский язык для детей 12 -17 лет онлайн",
                "lang=5": "Китайский язык для детей онлайн",
                "lang=5&age=1": "Китайский язык для малышей онлайн",
                "lang=5&age=2": "Китайский язык для дошкольников онлайн",
                "lang=5&age=3": "Китайский язык для для школьников онлайн",
                "lang=5&age=4": "Китайский язык для детей 12 -17 лет онлайн",
                "lang=6": "Русский язык для детей онлайн",
                "lang=6&age=1": "Русский язык для малышей онлайн",
                "lang=6&age=2": "Русский язык для дошкольников онлайн",
                "lang=6&age=3": "Русский язык для для школьников онлайн",
                "lang=6&age=4": "Русский язык для детей 12 -17 лет онлайн",
                "age=2": "Онлайн уроки иностранных языков для дошкольников",
                "age=1": "Онлайн уроки иностранных языков для малышей",
                "age=3": "Онлайн уроки иностранных языков для школьников",
                "": "Онлайн уроки иностранных языков для детей",
                "age=4": "Онлайн уроки иностранных языков для детей 12 -17 лет",
            },
        };
    },
    metaInfo() {
        return {
            title: this.metaTitle,
            meta: [
                {
                    vmid: "description",
                    name: "description",
                    content: this.metaDescription,
                },
            ],
        };
    },
    mounted() {
        this.loading = true;
        // this.security = "asutp";
        // if ("age" in this.$route.query) this.ageId = this.$route.query.age;
        // if ("lang" in this.$route.query) this.langId = this.$route.query.lang;
        // if ("diff" in this.$route.query) this.diffId = this.$route.query.diff;

        // if (this.ageId && !this.langId)
        //     this.$router.push("/courses?age=" + this.ageId);
        // if (!this.ageId && this.langId)
        //     this.$router.push("/courses?lang=" + this.langId);
        // if (!this.ageId && !this.langId) this.$router.push("/courses");

        // const queryParams = new URLSearchParams(this.$route.query).toString();
        // this.metaDescription = this.metaDescriptions[queryParams];
        // this.metaTitle = this.metaTitles[queryParams];

        // console.log(queryParams);
        // console.log(this.description);

        courseApi
            .fetchCoursesWithFilter(this.ageId, this.langId, this.diffId)
            .then((response) => {
                this.courses = response;
                // console.log(`ALL COURSES: ${JSON.stringify(this.courses)}`);
            })
            .catch((error) => {
                let data = error.response.data;
                this.error = this.pretty(data);
                this.loading = false;
            });
    },
    computed: {
        // coursesFiltered: function() {
        //     let filteredCourses = this.courses.filter((course) => {
        //         console.log(`COURSE LANG ID: ${course.idlanguage}`);
        //         return (
        //             course.idlanguage == this.langId &&
        //             course.ages.forEach((age) => age.idage == this.ageId)
        //         );
        //     });
        //     return filteredCourses;
        // },
    },

    methods: {
        order(course, addititionalPackage) {
            this.$parent.showCourseChoise = false;
            this.$parent.isCourseChoosed = true;
            this.$parent.recipent.choosedCourseId = course.idcourse;
            // console.log(this.$parent.recipent.choosedCourseId);

            // if (course.ordered) {
            //     if (addititionalPackage) {
            //         this.$router.push("/order/" + course.idcourse + "?addonly");
            //     } else {
            //         this.$router.push("/course/" + course.idcourse);
            //     }
            // } else {
            //     if (course.preorder) {
            //         if (this.$gtag)
            //             this.$gtag.event("preorder", {
            //                 event_category: "button",
            //             });
            //         if (this.$metrika) this.$metrika.reachGoal("preorder");
            //     } else {
            //         if (this.$gtag)
            //             this.$gtag.event("buy", { event_category: "button" });
            //         if (this.$metrika) this.$metrika.reachGoal("kupit");
            //     }
            //     if (addititionalPackage) {
            //         this.$router.push("/order/" + course.idcourse + "?add");
            //     } else {
            //         this.$router.push("/order/" + course.idcourse);
            //     }
            // }
        },
        demo(course) {
            if (course.freeLessonsCount > 0) {
                if (this.$gtag)
                    this.$gtag.event("try", { event_category: "button" });
                if (this.$metrika) this.$metrika.reachGoal("demo");
                this.$router.push("/course/" + course.slug);
            } else {
                this.$router.push("/order/" + course.idcourse);
            }
        },
        pretty(value) {
            if (value.message) {
                return value.message;
            }
            return JSON.stringify(value, null, 2);
        },
        courseDemoButtonLabel(course) {
            if (
                !course.ordered &&
                course.freeLessonsCount > 0 &&
                parseInt(course.price) > 0
            ) {
                return this.$t('try');
            }
            return null;
        },

        orderSubscription() {
            this.$router.push("/schedule");
        },
        fetchCoursesAndUpdate() {
            courseApi
                .fetchCoursesWithFilter(this.ageId, this.langId, this.diffId)
                .then((response) => {
                    this.courses = response;
                    console.log(
                        `TEST! age: ${this.ageId}, lang: ${this.langId}`
                    );
                })
                .catch((error) => {
                    let data = error.response.data;
                    this.error = this.pretty(data);
                    this.loading = false;
                });
        },
    },
};
</script>

<style scoped src="@/assets/hometeacher/css/main.css"></style>
<style scoped>
.CourseList {
    background-color: white;
}

.blue-bg {
    background-color: #caffbb;
    margin-top: 0px;
    box-shadow: inset 0 4px 6px #0000001a;
    padding-top: 30px;
}

.choose-course {
    text-align: left;
}

.title {
    text-align: left;
}
</style>
